import {GridColDef} from '@mui/x-data-grid-pro';
import {renderCellDate} from '../../../utils/renderCellDate';
import {renderCellCurrency} from '../../../utils/renderCellCurrency';

export const retirementColumns: GridColDef[] = [
  {
    field: 'typeOfGift',
    headerName: 'Gift Description',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'contact',
    headerName: 'Gifter',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.simplifiedName || '-';
    },
  },
  {
    field: 'recipientName',
    headerName: 'Recipient Name',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'giftValue',
    headerName: 'Gift Value',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellCurrency,
  },
  {
    field: 'currentStatus',
    headerName: 'Current Status',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'dateOfGift',
    headerName: 'Date of gift',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellDate,
  },
];
